<template>
   <div id="actividades">
      <div v-if="loading" id="loading" class="loading_full">Loading&#8230;</div>
      <div class="card">
         <div class="card-body">
            <div class="text-center section">
               <h2 class="h2 mb-4 fw-bold text-primary">
                  Calendario de Tareas
               </h2>

               <div class="container">
                  <div class="col-lg-12">
                     <vc-calendar
                        ref="calendar"
                        class="custom-calendar max-w-full"
                        :masks="masks"
                        :attributes="schedule"
                        @update:from-page="onMonthChange"
                        disable-page-swipe
                        is-expanded
                     >
                        <template v-slot:day-content="{ day, attributes }">
                           <div
                              class="flex flex-col h-full z-10 overflow-hidden"
                              style="min-height: max-content"
                              data-bs-toggle="modal"
                              data-bs-target="#schedule"
                              @click="getScheduleDay(day)"
                           >
                              <span class="day-label text-sm text-gray-900">{{
                                 day.day
                              }}</span>
                              <div
                                 class="flex-grow overflow-y-auto overflow-x-auto"
                              >
                                 <p
                                    v-for="attr in attributes"
                                    :key="attr.key"
                                    class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
                                    :class="attr.customData.class"
                                 >
                                    {{ attr.customData.title }}
                                 </p>
                              </div>
                           </div>
                        </template>
                     </vc-calendar>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div
         class="modal fade"
         id="schedule"
         tabindex="-1"
         aria-labelledby="scheduleLabel"
         aria-hidden="true"
      >
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h3
                     class="modal-title text-primary fw-bolder"
                     id="scheduleLabel"
                  >
                     Agenda
                  </h3>
                  <button type="button" class="close" data-bs-dismiss="modal">
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body bg-light">
                  <div v-if="scheduleDay.length != 0">
                     <div
                        v-for="(task, index_task) in scheduleDay"
                        :key="index_task"
                        class="card border mb-2"
                     >
                        <div class="card-body py-2">
                           <div
                              v-if="task.alert === true"
                              class="text-danger fw-bolder py-2 mb-2"
                           >
                              <i class="fa fa-exclamation-triangle"></i>
                              Tarea vencida
                           </div>
                           <div class="d-flex align-items-start">
                              <div
                                 class="text-start flex-grow-1 pe-2"
                                 style="min-width: 0"
                              >
                                 <small class="text-muted d-block">
                                    {{ task.date_format || task.date }}
                                 </small>
                                 <h6 class="mb-0 text-primary">
                                    <router-link
                                       :to="'/reserva/' + task.id_reserva"
                                       target="_blank"
                                       class="d-block text-break"
                                    >
                                       <span>
                                          {{ task.description }}
                                       </span>
                                    </router-link>
                                 </h6>
                              </div>
                              <div
                                 class="form-check form-switch ms-4 mt-3 flex-shrink-0"
                              >
                                 <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="`task-day-status-${index_task}`"
                                    :checked="isTaskCompleted(task)"
                                    @change="
                                       updateScheduleTaskStatus(
                                          task,
                                          $event.target.checked,
                                       )
                                    "
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div v-else class="alert alert-light mb-0">
                     No hay tareas para esta fecha.
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import axios from "axios";
export default {
   name: "Calendario",
   metaInfo: {
      title: "Calendario - Backoffice",
   },
   data() {
      return {
         loading: false,
         month: null,
         day: null,
         masks: {
            weekdays: "WWW",
         },
         schedule: [],
         scheduleDay: [],
      };
   },
   props: {
      session: Object,
   },
   created() {
      this.month = new Date().toISOString().slice(0, 7);
      this.getSchedules();
   },
   methods: {
      getSchedules() {
         this.loading = true;
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
            params: {
               month: this.month,
            },
         };
         axios
            .get(vm.$base_url + "calendar/schedule", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  let schedule = response.data.data.schedule;

                  schedule.forEach((item) => {
                     item.customData = {
                        title: item.description,
                        class: item.alert
                           ? "badge bg-danger text-white"
                           : "badge bg-success text-white",
                     };
                     item.dates = vm.parseDateAsLocal(item.date);
                  });

                  vm.schedule = schedule;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
               vm.loading = false;
            });
      },
      getScheduleDay(day) {
         this.loading = true;
         let date = new Date(day.date);
         // Ajustamos la fecha al formato YYYY-MM-DD para evitar problemas de zona horaria.
         this.day = date.toISOString().slice(0, 10);
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
            params: {
               date: this.day,
            },
         };
         axios
            .get(vm.$base_url + "calendar/scheduleDay", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  this.scheduleDay = response.data.data.schedule;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
               vm.loading = false;
            });
      },
      parseDateAsLocal(dateValue) {
         if (!dateValue) return null;

         // Si viene YYYY-MM-DD, lo convertimos a fecha local para evitar desfase por UTC.
         if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
            const [year, month, day] = dateValue.split("-").map(Number);
            return new Date(year, month - 1, day);
         }

         return new Date(dateValue);
      },
      onMonthChange(page) {
         const month = String(page.month).padStart(2, "0");
         const nextMonth = page.year + "-" + month;

         if (nextMonth === this.month) {
            return;
         }

         this.month = nextMonth;
         this.getSchedules();
      },
      isTaskCompleted(task) {
         return Number(task.status) === 1;
      },
      updateScheduleTaskStatus(task, checked) {
         const vm = this;
         const prevStatus = task.status;
         task.status = checked ? 1 : 0;

         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };

         let params = {
            task: task,
         };

         axios
            .post(vm.$base_url + "reservas/updateStatusTask", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  task.status = prevStatus;
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Tareas",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Tareas",
                     text: response.data.message,
                  });
                  vm.getSchedules();
               }
            })
            .catch((error) => {
               task.status = prevStatus;
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            })
            .finally();
      },
   },
   mounted() {},
};
</script>

<style scoped>
::-webkit-scrollbar {
   width: 0px;
}

::-webkit-scrollbar-track {
   display: none;
}

:deep(.custom-calendar.vc-container) {
   --day-border: 1px solid #dddddd;
   --day-border-highlight: 1px solid #b8c2cc;
   --day-width: 90px;
   --day-height: 90px;
   --weekday-bg: #ffffff;
   --weekday-border: 1px solid #eaeaea;

   border-radius: 25px;
   width: 100%;
}

/* Header */
:deep(.custom-calendar.vc-container .vc-header) {
   padding: 10px 0;
}

/* Weeks */
:deep(.custom-calendar.vc-container .vc-weeks) {
   padding: 0;
}

/* Weekday */
:deep(.custom-calendar.vc-container .vc-weekday) {
   background-color: var(--weekday-bg);
   border-bottom: var(--weekday-border);
   border-top: var(--weekday-border);
   padding: 5px 0;
}

/* Day */
:deep(.custom-calendar.vc-container .vc-day) {
   padding: 0 5px 3px 5px;
   text-align: center;
   height: var(--day-height);
   min-width: var(--day-width);
   background-color: white;
   color: #444746;
   font-size: 0.975rem;
}

:deep(.day-label) {
   cursor: pointer;
}

:deep(.day-label:hover) {
   font-weight: bold;
   background-color: #ffd493;
   border-radius: 25px;
   padding: 2px 5px;
   font-size: 1rem;
}

/* Weekend highlight */
:deep(.custom-calendar.vc-container .vc-day.weekday-1),
:deep(.custom-calendar.vc-container .vc-day.weekday-7) {
   background-color: #fbf7f3;
}

/* Bottom border */
:deep(.custom-calendar.vc-container .vc-day:not(.on-bottom)) {
   border-bottom: var(--day-border);
}

:deep(.custom-calendar.vc-container .vc-day:not(.on-bottom).weekday-1) {
   border-bottom: var(--day-border-highlight);
}

/* Right border */
:deep(.custom-calendar.vc-container .vc-day:not(.on-right)) {
   border-right: var(--day-border);
}

/* Dots */
:deep(.custom-calendar.vc-container .vc-day-dots) {
   margin-bottom: 5px;
}
</style>
